import React from "react";
import styled from "styled-components";

const CheckboxWrapper = styled.label`
  font-size: 14px;
  line-height: 20px;
`;

const CheckboxLabel = styled.span`padding-left: 6px;`;

// We specify onChange and onBlur because the browser does weird things
const Checkbox = ({ input, ...otherProps }) => (
  <NativeCheckbox 
    {...input}
    checked={input.value}
    onChange={e => input.onChange(e.target.checked)}
    onBlur={e => input.onBlur(e.target.checked)}
    {...otherProps}
  />
);

export const NativeCheckbox = ({ name, checked, onChange, onBlur, children, labelText, inputProps, ...otherProps }) => (
  <CheckboxWrapper {...otherProps}>
    <input
      {...inputProps}
      name={name}
      checked={checked}
      onChange={onChange}
      onBlur={onBlur}
      type="checkbox"
    />
    {(children || labelText) && (
      <CheckboxLabel>{children || labelText}</CheckboxLabel>
    )}
  </CheckboxWrapper>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/forms/Checkbox.js